"use strict";

exports.__esModule = true;
var _UpdateDeviceScreen = require("./UpdateDeviceScreen");
Object.keys(_UpdateDeviceScreen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _UpdateDeviceScreen[key]) return;
  exports[key] = _UpdateDeviceScreen[key];
});